import { supabase } from "@/integrations/supabase/client";

export async function getIntegration(key: string): Promise<string | null> {
  const { data, error } = await supabase
    .from("integrations")
    .select("value")
    .eq("key", key)
    .single();

  if (error) return null;
  return data?.value ?? null;
}

export async function updateIntegration(key: string, value: string): Promise<void> {
  const { error } = await supabase
    .from("integrations")
    .upsert({ key, value, updated_at: new Date().toISOString() });

  if (error) throw error;
}

export async function getAllIntegrations(): Promise<Record<string, string>> {
  const { data, error } = await supabase.from("integrations").select("key, value");

  if (error) throw error;

  const result: Record<string, string> = {};
  for (const item of data ?? []) {
    result[item.key] = item.value ?? "";
  }
  return result;
}
